export default value => {
  const input = document.createElement('input');
  input.value = value;
  document.body.appendChild(input);
  input.select();
  if (document.execCommand('Copy')) {
    document.execCommand('Copy');
  }
  input.remove();
  // console.log('copied TO DO notif');
  // TODO Vue.prototype.$noty.success('Copied!', { timeout: 500 });
};
